import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Stack } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { RegistrationButton } from '../RegistrationButton/index.js';
import { KeepMeInformedCheckbox } from '../KeepMeInformedCheckbox/index.js';
import { RegistrationEmailInput, RegistrationPasswordInput, } from '../Inputs/index.js';
import { validateEmail } from '../../../../helpers/validateEmail.js';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.js';
import { emailSelector, passwordSelector, registrationThunk, updateEmailError, updateEmailErrorMessage, updatePasswordError, updatePasswordErrorMessage, } from '../../registrationSlice.js';
import { validatePassword } from '../../../../helpers/validatePassword.js';
import { hasKeepMeInformedEnabled, registrationConsentPositionSelector, } from '../../../../redux/core/siteConfig/siteConfigSlice.js';
import { RegistrationConsent } from '../RegistrationConsent/index.js';
import { isInTwoStepWrapper } from '../../../../tracking/constants.js';
import { useTrack } from '../../../../tracking/common/hooks/useTrack.js';
import { activeWrapperSelector } from '../../../../redux/core/wrapperContext/wrapperContextSlice.js';
import { AutoCompleteFormWrapper } from '../../../../components/common/AutoCompleteFormWrapper/AutoCompleteFormWrapper.js';
export const RegistrationWithEmailForm = () => {
    const keepMeInformedCheckbox = useAppSelector(hasKeepMeInformedEnabled);
    const { t } = useTranslation();
    const emailState = useAppSelector(emailSelector);
    const passwordState = useAppSelector(passwordSelector);
    const registrationConsentPosition = useAppSelector(registrationConsentPositionSelector);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const dispatch = useAppDispatch();
    const { trackBtnClick, trackFieldError } = useTrack(isInTwoStepWrapper(activeWrapper) ? 'twoStep' : 'standard');
    const registrationButtonClick = () => {
        trackBtnClick({ uniqueName: 'registerWithEmailPassword' });
        const validEmail = validateEmail(emailState.value);
        const validPassword = validatePassword(passwordState.value);
        if (!validEmail) {
            if (validPassword) {
                trackFieldError({ formFieldErrors: 'emailAddressNotValid' });
            }
            else {
                trackFieldError({ formFieldErrors: 'bothFieldsNotValid' });
            }
            dispatch(updateEmailError(!validEmail));
            dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
        }
        if (!validPassword) {
            if (validEmail) {
                trackFieldError({ formFieldErrors: 'passwordNotValid' });
            }
            dispatch(updatePasswordError(!validPassword));
            dispatch(updatePasswordErrorMessage(t('loginregistration.password.validation.error')));
        }
        if (validEmail && validPassword) {
            dispatch(registrationThunk());
        }
    };
    const ddActionName = isInTwoStepWrapper(activeWrapper)
        ? `rla_forms_twoStep_registerWithEmailPasswordClick`
        : `rla_forms_standard_registerWithEmailPasswordClick`;
    return (_jsx(Stack, { direction: ['vertical'], spacing: ['spaceS'], children: _jsxs(AutoCompleteFormWrapper, { children: [_jsxs(Stack, { direction: ['vertical'], spacing: ['spaceL'], children: [_jsx(RegistrationEmailInput, {}), _jsx(RegistrationPasswordInput, {})] }), registrationConsentPosition === 'top' && _jsx(RegistrationConsent, {}), keepMeInformedCheckbox && _jsx(KeepMeInformedCheckbox, {}), _jsx(RegistrationButton, { onClick: registrationButtonClick, ddActionName: ddActionName })] }) }));
};
//# sourceMappingURL=RegistrationWithEmailForm.js.map